/**
 * Luxury Fragrance Recommendation Agent Quiz - BestPerfume.Store
 * Fast, premium, click-only, fully deterministic.
 */

document.addEventListener("DOMContentLoaded", function () {
  // ==========================================================================
  // 1. Dynamic Fragrance Metadata & Scoring Engine
  // ==========================================================================
  // The quiz engine scores all Shopify storefront products dynamically
  // based on Shopify tags, collections and the richText metafield.

  // ==========================================================================
  // 2. DOM Variables & References
  // ==========================================================================
  const landingScreen = document.getElementById("bps-landing-screen");
  const startBtn = document.getElementById("bps-start-quiz-btn");
  const quizContainer = document.getElementById("bps-quiz-container");
  const slides = Array.from(document.querySelectorAll(".bps-quiz-slide"));
  const progressFill = document.getElementById("bps-progress-fill");
  const progressText = document.getElementById("bps-progress-text");
  const chipsContainer = document.getElementById("bps-selected-chips-container");
  const backBtn = document.getElementById("bps-back-btn");

  const loadingScreen = document.getElementById("bps-loading-screen");
  const resultsScreen = document.getElementById("bps-results-screen");
  const resultsCardsContainer = document.getElementById("bps-results-cards-container");
  const resultsProfileLine = document.getElementById("bps-results-profile-line");
  const restartBtn = document.getElementById("bps-restart-quiz-btn");

  // Added by the updated Liquid file.
  const currentPerfumesInput = document.getElementById("bps-current-perfumes-input");
  const currentPerfumesNextBtn = document.getElementById("bps-current-perfumes-next-btn");

  // ==========================================================================
  // 3. Quiz State Variables
  // ==========================================================================
  let currentStep = 1;

  const answers = {
    intent: "",
    direction: "",
    reference: "",
    desired_effect: "",
    occasion: "",
    avoid: [],
    strength: "",
    current_perfumes: []
  };

  const stepSelectionsMeta = {};

  let shopifyCatalog = [];

  // Parse dynamic catalog data from Liquid DOM element safely.
  try {
    const dataContainer = document.getElementById("bps-shopify-catalog-json");

    if (dataContainer && dataContainer.textContent) {
      shopifyCatalog = JSON.parse(dataContainer.textContent);

      console.log(
        "[Quiz] Parsed shopifyCatalog successfully. Count:",
        shopifyCatalog.length
      );

      if (shopifyCatalog.length > 0) {
        console.log(
          "[Quiz] First 5 products in storefront catalog:",
          shopifyCatalog.slice(0, 5)
        );
      } else {
        console.warn(
          "[Quiz] Catalog parsed successfully but returned 0 products!"
        );
      }
    } else {
      console.error(
        "[Quiz] Catalog JSON script block was not found or has no content!"
      );
    }
  } catch (e) {
    console.error("[Quiz] Catalog parse error:", e);
  }

  // ==========================================================================
  // 4. Navigation & Slides Control Flow
  // ==========================================================================

  startBtn.addEventListener("click", function () {
    landingScreen.classList.add("bps-d-none");
    quizContainer.classList.remove("bps-d-none");

    currentStep = 1;

    updateStepView();

    trackEvent("quiz_started", {
      source: "quiz_page",
      timestamp: Date.now()
    });
  });

  // Main event listener for quiz buttons.
  document.querySelectorAll(".bps-option-card").forEach(function (card) {
    card.addEventListener("click", function () {
      const slide = card.closest(".bps-quiz-slide");
      const stepId = slide.getAttribute("data-step-id");
      const stepNum = parseInt(slide.getAttribute("data-step"), 10);
      const val = card.getAttribute("data-value");
      const symbol = card.getAttribute("data-symbol") || "";
      const titleEl = card.querySelector(".bps-option-title");
      const title = titleEl ? titleEl.textContent : val;
      const note = card.getAttribute("data-note") || title;

      slide.querySelectorAll(".bps-option-card").forEach(function (optionCard) {
        optionCard.classList.remove("is-selected");
      });

      card.classList.add("is-selected");

      if (stepId === "avoid") {
        answers.avoid = val === "none" ? [] : [val];
      } else {
        answers[stepId] = val;
      }

      stepSelectionsMeta[stepNum] = {
        symbol: symbol,
        label: note
      };

      trackStepAnswer(stepId, val, symbol, title);

      setTimeout(function () {
        navigateNext();
      }, 250);
    });
  });

  // Optional 1–3 named perfumes question.
  if (currentPerfumesNextBtn) {
    currentPerfumesNextBtn.addEventListener("click", function () {
      const entries = parsePerfumeEntries(
        currentPerfumesInput ? currentPerfumesInput.value : ""
      );

      answers.current_perfumes = entries;

      const slide = currentPerfumesNextBtn.closest(".bps-quiz-slide");

      const stepNum = slide
        ? parseInt(slide.getAttribute("data-step"), 10)
        : currentStep;

      if (entries.length > 0) {
        stepSelectionsMeta[stepNum] = {
          symbol: "✦",
          label: entries.join(", ")
        };
      } else {
        delete stepSelectionsMeta[stepNum];
      }

      trackStepAnswer(
        "current_perfumes",
        entries,
        "✦",
        entries.length > 0 ? entries.join(", ") : "Skipped"
      );

      navigateNext();
    });
  }

  if (currentPerfumesInput && currentPerfumesNextBtn) {
    currentPerfumesInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        currentPerfumesNextBtn.click();
      }
    });
  }

  backBtn.addEventListener("click", function () {
    if (currentStep > 1) {
      currentStep--;
      updateStepView();
    } else {
      quizContainer.classList.add("bps-d-none");
      landingScreen.classList.remove("bps-d-none");
    }
  });

  restartBtn.addEventListener("click", resetQuiz);

  function navigateNext() {
    if (currentStep < slides.length) {
      currentStep++;
      updateStepView();
    } else {
      triggerLoadingAndResults();
    }
  }

  function updateStepView() {
    const totalSteps = slides.length || 1;

    slides.forEach(function (slide, idx) {
      if (idx + 1 === currentStep) {
        slide.classList.add("active");
      } else {
        slide.classList.remove("active");
      }
    });

    const progressVal = Math.round(
      ((currentStep - 1) / totalSteps) * 100
    );

    progressFill.style.width = progressVal + "%";
    progressText.textContent = progressVal + "%";

    renderSelectedChips();
  }

  function renderSelectedChips() {
    chipsContainer.innerHTML = "";

    for (let stepNum = 1; stepNum < currentStep; stepNum++) {
      const meta = stepSelectionsMeta[stepNum];

      if (meta) {
        const chip = document.createElement("div");

        chip.className = "bps-selected-note";

        chip.innerHTML = `
          <span class="bps-selected-note-symbol">
            ${escapeHtml(meta.symbol)}
          </span>
          ${escapeHtml(meta.label)}
        `;

        chipsContainer.appendChild(chip);
      }
    }
  }

  function resetQuiz() {
    currentStep = 1;

    answers.intent = "";
    answers.direction = "";
    answers.reference = "";
    answers.desired_effect = "";
    answers.occasion = "";
    answers.avoid = [];
    answers.strength = "";
    answers.current_perfumes = [];

    Object.keys(stepSelectionsMeta).forEach(function (key) {
      delete stepSelectionsMeta[key];
    });

    if (currentPerfumesInput) {
      currentPerfumesInput.value = "";
    }

    document.querySelectorAll(".bps-option-card").forEach(function (card) {
      card.classList.remove("is-selected");
    });

    resultsScreen.classList.add("bps-d-none");
    loadingScreen.classList.add("bps-d-none");
    quizContainer.classList.add("bps-d-none");
    landingScreen.classList.remove("bps-d-none");
  }

  function triggerLoadingAndResults() {
    quizContainer.classList.add("bps-d-none");
    loadingScreen.classList.remove("bps-d-none");

    setTimeout(function () {
      loadingScreen.classList.add("bps-d-none");
      resultsScreen.classList.remove("bps-d-none");

      renderRecommendedProducts();
    }, 1800);
  }

  // ==========================================================================
  // 5. Scoring & Matching Helpers
  // ==========================================================================

  const REFERENCE_TAG_GROUPS = {
    // Fresh & Bold
    sauvage: [
      "fresh",
      "citrus",
      "aromatic",
      "spicy"
    ],

    fresh_bold: [
      "fresh",
      "citrus",
      "aromatic",
      "spicy"
    ],

    "fresh-bold": [
      "fresh",
      "citrus",
      "aromatic",
      "spicy"
    ],

    // Clean & Classy
    bdc: [
      "clean",
      "woody",
      "musk",
      "musky",
      "aromatic"
    ],

    clean_classy: [
      "clean",
      "woody",
      "musk",
      "musky",
      "aromatic"
    ],

    "clean-classy": [
      "clean",
      "woody",
      "musk",
      "musky",
      "aromatic"
    ],

    // Light & Airy
    jo_malone: [
      "floral",
      "fruity",
      "green",
      "sea",
      "powdery"
    ],

    light_airy: [
      "floral",
      "fruity",
      "green",
      "sea",
      "powdery"
    ],

    "light-airy": [
      "floral",
      "fruity",
      "green",
      "sea",
      "powdery"
    ],

    // Sweet & Warm
    baccarat: [
      "sweet",
      "vanilla",
      "warm",
      "amber",
      "tobacco",
      "oud",
      "leather",
      "powdery"
    ],

    sweet_warm: [
      "sweet",
      "vanilla",
      "warm",
      "amber",
      "tobacco",
      "oud",
      "leather",
      "powdery"
    ],

    "sweet-warm": [
      "sweet",
      "vanilla",
      "warm",
      "amber",
      "tobacco",
      "oud",
      "leather",
      "powdery"
    ]
  };

  const PERFUME_SUFFIXES = [
    "eau de toilette",
    "eau de parfum",
    "eau fraiche",
    "elixir",
    "parfum",
    "intense",
    "fraiche",
    "extrait",
    "edt",
    "edp"
  ];

  function normalizeArray(values) {
    return (values || []).map(function (value) {
      return String(value || "").toLowerCase().trim();
    });
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function htmlToPlainText(value) {
    const temp = document.createElement("div");

    temp.innerHTML = String(value || "");

    return temp.textContent || temp.innerText || "";
  }

  function normalizeSearchText(value) {
    return htmlToPlainText(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[’']/g, "")
      .replace(/[–—]/g, "-")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizePerfumeCore(value) {
    let normalized = normalizeSearchText(value)
      .replace(
        /\b(inspired by|inspiration of|resemblance to|resembles|similar to|smells like|our take on|version of)\b/g,
        " "
      )
      .replace(/\s+/g, " ")
      .trim();

    let changed = true;

    while (changed) {
      changed = false;

      PERFUME_SUFFIXES.forEach(function (suffix) {
        const pattern = new RegExp(
          "\\s+" +
            suffix.replace(/\s+/g, "\\s+") +
            "\\s*$",
          "i"
        );

        if (pattern.test(normalized)) {
          normalized = normalized
            .replace(pattern, " ")
            .replace(/\s+/g, " ")
            .trim();

          changed = true;
        }
      });
    }

    return normalized;
  }

  function parsePerfumeEntries(value) {
    const rawEntries = String(value || "")
      .split(/[\n,;]+/)
      .map(function (entry) {
        return entry.trim();
      })
      .filter(Boolean);

    const seen = new Set();
    const uniqueEntries = [];

    rawEntries.forEach(function (entry) {
      const normalized = normalizePerfumeCore(entry);

      if (
        normalized &&
        !seen.has(normalized) &&
        uniqueEntries.length < 3
      ) {
        seen.add(normalized);
        uniqueEntries.push(entry);
      }
    });

    return uniqueEntries;
  }

  function isAnyAnswer(value) {
    return [
      "",
      "any",
      "all",
      "unknown",
      "not_sure",
      "none"
    ].includes(String(value || "").toLowerCase());
  }

  function getProductGender(product) {
    const tags = normalizeArray(product.tags);
    const collections = normalizeArray(product.collections);

    return {
      men:
        tags.includes("men") ||
        collections.includes("men"),

      women:
        tags.includes("women") ||
        collections.includes("women"),

      unisex:
        tags.includes("unisex") ||
        collections.includes("unisex")
    };
  }

  // Normal results:
  // Men = Men
  // Women = Women
  // Unisex = Unisex
  // All = all three
  function passesStrictGender(product) {
    const direction = String(
      answers.direction || ""
    ).toLowerCase();

    const gender = getProductGender(product);

    if (isAnyAnswer(direction)) {
      return gender.men || gender.women || gender.unisex;
    }

    if (direction === "men") {
      return gender.men;
    }

    if (direction === "women") {
      return gender.women;
    }

    if (direction === "unisex") {
      return gender.unisex;
    }

    return true;
  }

  // Named perfume override:
  // Men selection allows Men or Unisex.
  // Women selection allows Women or Unisex.
  // Unisex selection allows Men, Women or Unisex.
  // All selection allows all three.
  function passesNamedMatchGender(product) {
    const direction = String(
      answers.direction || ""
    ).toLowerCase();

    const gender = getProductGender(product);

    if (isAnyAnswer(direction)) {
      return gender.men || gender.women || gender.unisex;
    }

    if (direction === "men") {
      return gender.men || gender.unisex;
    }

    if (direction === "women") {
      return gender.women || gender.unisex;
    }

    if (direction === "unisex") {
      return gender.men || gender.women || gender.unisex;
    }

    return true;
  }

  function getReferenceScore(productTags) {
    const reference = String(
      answers.reference || ""
    ).toLowerCase();

    if (isAnyAnswer(reference)) {
      return 0;
    }

    const mappedTags =
      REFERENCE_TAG_GROUPS[reference] || [];

    // Treat musk and musky as one note family.
    const productTagSet = new Set(
      productTags.map(function (tag) {
        return tag === "musky" ? "musk" : tag;
      })
    );

    const mappedTagSet = new Set(
      mappedTags.map(function (tag) {
        return tag === "musky" ? "musk" : tag;
      })
    );

    let matchCount = 0;

    mappedTagSet.forEach(function (tag) {
      if (productTagSet.has(tag)) {
        matchCount++;
      }
    });

    if (matchCount >= 3) {
      return 100;
    }

    if (matchCount === 2) {
      return 67;
    }

    if (matchCount === 1) {
      return 33;
    }

    return 0;
  }

  function getOccasionScore(richText) {
    const occasion = String(
      answers.occasion || ""
    ).toLowerCase();

    const description =
      normalizeSearchText(richText);

    const allDay =
      description.includes(
        "suitable for all-day use"
      ) ||
      description.includes(
        "suitable for all day use"
      );

    const day = description.includes(
      "suitable for day use"
    );

    const night = description.includes(
      "suitable for night use"
    );

    if (occasion === "everyday") {
      return allDay ? 100 : 0;
    }

    if (
      [
        "office",
        "work",
        "school",
        "work_school",
        "work-school"
      ].includes(occasion)
    ) {
      return day || allDay ? 100 : 0;
    }

    if (
      [
        "date",
        "date_night",
        "date-night"
      ].includes(occasion)
    ) {
      return night ? 100 : 0;
    }

    if (
      [
        "party",
        "club",
        "party_club",
        "party-club"
      ].includes(occasion)
    ) {
      return allDay || night ? 100 : 0;
    }

    return 0;
  }

  function getStrengthScore(productTags) {
    const strength = String(
      answers.strength || ""
    ).toLowerCase();

    if (isAnyAnswer(strength)) {
      return 0;
    }

    if (strength === "light") {
      return productTags.includes("light")
        ? 100
        : 0;
    }

    if (strength === "moderate") {
      return productTags.includes("moderate")
        ? 100
        : 0;
    }

    if (strength === "strong") {
      return productTags.includes("strong")
        ? 100
        : 0;
    }

    return 0;
  }

  function getActiveMaximumScore() {
    let maximum = 0;

    if (!isAnyAnswer(answers.reference)) {
      maximum += 100;
    }

    if (!isAnyAnswer(answers.occasion)) {
      maximum += 100;
    }

    if (!isAnyAnswer(answers.strength)) {
      maximum += 100;
    }

    return maximum || 100;
  }

  const PERFUME_MATCH_IGNORED_WORDS = new Set([
    "inspired",
    "inspiration",
    "resemblance",
    "resembles",
    "resembling",
    "similar",
    "smells",
    "like",
    "our",
    "take",
    "on",
    "version",
    "of",
    "by",
    "and",
    "eau",
    "de",
    "toilette",
    "parfum",
    "perfume",
    "cologne",
    "elixir",
    "intense",
    "fraiche",
    "extrait",
    "edt",
    "edp"
  ]);

  function getPerfumeMatchTokens(value) {
    return normalizeSearchText(value)
      .split(/\s+/)
      .filter(Boolean)
      .filter(function (token) {
        return (
          token.length > 1 &&
          !PERFUME_MATCH_IGNORED_WORDS.has(token)
        );
      });
  }

  function getTypoDistanceLimit(tokenLength) {
    if (tokenLength <= 3) {
      return 0;
    }

    if (tokenLength <= 5) {
      return 1;
    }

    return 2;
  }

  // Measures spelling difference, including changed, missing, extra
  // and swapped adjacent letters.
  function getEditDistance(firstValue, secondValue) {
    const first = String(firstValue || "");
    const second = String(secondValue || "");

    const rows = first.length + 1;
    const cols = second.length + 1;

    const matrix = Array.from(
      { length: rows },
      function () {
        return new Array(cols).fill(0);
      }
    );

    for (let i = 0; i < rows; i++) {
      matrix[i][0] = i;
    }

    for (let j = 0; j < cols; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i < rows; i++) {
      for (let j = 1; j < cols; j++) {
        const substitutionCost =
          first[i - 1] === second[j - 1]
            ? 0
            : 1;

        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + substitutionCost
        );

        // Detect swapped adjacent letters.
        if (
          i > 1 &&
          j > 1 &&
          first[i - 1] === second[j - 2] &&
          first[i - 2] === second[j - 1]
        ) {
          matrix[i][j] = Math.min(
            matrix[i][j],
            matrix[i - 2][j - 2] + 1
          );
        }
      }
    }

    return matrix[first.length][second.length];
  }

  function tokensMatchWithTypoTolerance(
    enteredToken,
    productToken
  ) {
    if (enteredToken === productToken) {
      return true;
    }

    const maximumLength = Math.max(
      enteredToken.length,
      productToken.length
    );

    const allowedDistance =
      getTypoDistanceLimit(maximumLength);

    // Short words must match exactly.
    if (allowedDistance === 0) {
      return false;
    }

    // Require the same opening letter to reduce unrelated matches.
    if (
      enteredToken.charAt(0) !==
      productToken.charAt(0)
    ) {
      return false;
    }

    if (
      Math.abs(
        enteredToken.length -
        productToken.length
      ) > allowedDistance
    ) {
      return false;
    }

    // Avoid treating a genuine longer word as a typo.
    // Example: "flora" should not match "floral".
    if (
      enteredToken.startsWith(productToken) ||
      productToken.startsWith(enteredToken)
    ) {
      return false;
    }

    return (
      getEditDistance(
        enteredToken,
        productToken
      ) <= allowedDistance
    );
  }

  function productMatchesNamedPerfume(
    product,
    enteredPerfume
  ) {
    const enteredTokens = Array.from(
      new Set(
        getPerfumeMatchTokens(
          enteredPerfume
        )
      )
    );

    const productTokens = Array.from(
      new Set(
        getPerfumeMatchTokens(
          product.richText || ""
        )
      )
    );

    if (
      enteredTokens.length === 0 ||
      productTokens.length === 0
    ) {
      return false;
    }

    // Every entered word must match a unique word from the Shopify
    // resemblance metafield. Word order does not matter.
    const usedProductIndexes = new Set();

    return enteredTokens.every(
      function (enteredToken) {
        let bestMatchIndex = -1;
        let bestDistance = Infinity;

        productTokens.forEach(
          function (productToken, index) {
            if (usedProductIndexes.has(index)) {
              return;
            }

            if (
              !tokensMatchWithTypoTolerance(
                enteredToken,
                productToken
              )
            ) {
              return;
            }

            const distance =
              getEditDistance(
                enteredToken,
                productToken
              );

            if (distance < bestDistance) {
              bestDistance = distance;
              bestMatchIndex = index;
            }
          }
        );

        if (bestMatchIndex === -1) {
          return false;
        }

        usedProductIndexes.add(
          bestMatchIndex
        );

        return true;
      }
    );
  }

  // ==========================================================================
  // 6. Deterministic Scoring Logic Engine
  // ==========================================================================

  function getScoredProducts() {
    const scoredList = [];

    console.log(
      "[Quiz Scoring] Starting dynamic storefront catalog scoring engine. Current answers:",
      answers
    );

    console.log(
      "[Quiz Scoring] Total storefront catalog size to score:",
      shopifyCatalog.length
    );

    shopifyCatalog.forEach(function (product) {
      const productTags =
        normalizeArray(product.tags);

      const referenceScore =
        getReferenceScore(productTags);

      const occasionScore =
        getOccasionScore(product.richText || "");

      const strengthScore =
        getStrengthScore(productTags);

      const coreScore =
        referenceScore +
        occasionScore +
        strengthScore;

      // Bestseller is applied only after core fit is calculated.
      const bestsellerBonus =
        productTags.includes("bestseller")
          ? 20
          : 0;

      scoredList.push({
        shopifyProduct: product,
        score: coreScore + bestsellerBonus,
        coreScore: coreScore,
        bestsellerBonus: bestsellerBonus,
        referenceScore: referenceScore,
        occasionScore: occasionScore,
        strengthScore: strengthScore
      });
    });

    return scoredList.sort(function (a, b) {
      if (b.score !== a.score) {
        return b.score - a.score;
      }

      if (b.coreScore !== a.coreScore) {
        return b.coreScore - a.coreScore;
      }

      const aAvailable =
        a.shopifyProduct.available !== false
          ? 1
          : 0;

      const bAvailable =
        b.shopifyProduct.available !== false
          ? 1
          : 0;

      if (bAvailable !== aAvailable) {
        return bAvailable - aAvailable;
      }

      return String(
        a.shopifyProduct.title || ""
      ).localeCompare(
        String(b.shopifyProduct.title || "")
      );
    });
  }

  // ==========================================================================
  // 7. Results Selection & Dynamic Markup Rendering
  // ==========================================================================

  function renderRecommendedProducts() {
    const allScored = getScoredProducts();
    const assignedIds = new Set();
    const recommendedSlots = [];

    const perfumeEntries =
      answers.current_perfumes || [];

    // Named exact/flanker matches take the first positions
    // in the same order entered by the customer.
    perfumeEntries.forEach(function (enteredPerfume) {
      if (recommendedSlots.length >= 10) {
        return;
      }

      const matchingProducts =
        allScored.filter(function (item) {
          return (
            !assignedIds.has(
              item.shopifyProduct.id
            ) &&
            passesNamedMatchGender(
              item.shopifyProduct
            ) &&
            productMatchesNamedPerfume(
              item.shopifyProduct,
              enteredPerfume
            )
          );
        });

      const selectedMatch =
        matchingProducts.find(function (item) {
          return (
            item.shopifyProduct.available !== false
          );
        }) ||
        matchingProducts[0];

      if (selectedMatch) {
        selectedMatch.isNamedMatch = true;

        selectedMatch.namedMatchInput =
          enteredPerfume;

        assignedIds.add(
          selectedMatch.shopifyProduct.id
        );

        recommendedSlots.push(
          selectedMatch
        );
      }
    });

    // Fill remaining slots using strict gender and Q2–Q4 ranking.
    const remainingMatches =
      allScored.filter(function (item) {
        return (
          !assignedIds.has(
            item.shopifyProduct.id
          ) &&
          passesStrictGender(
            item.shopifyProduct
          )
        );
      });

    const availableMatches =
      remainingMatches.filter(function (item) {
        return (
          item.shopifyProduct.available !== false
        );
      });

    const soldOutMatches =
      remainingMatches.filter(function (item) {
        return (
          item.shopifyProduct.available === false
        );
      });

    availableMatches
      .concat(soldOutMatches)
      .forEach(function (item) {
        if (recommendedSlots.length >= 10) {
          return;
        }

        if (
          assignedIds.has(
            item.shopifyProduct.id
          )
        ) {
          return;
        }

        assignedIds.add(
          item.shopifyProduct.id
        );

        recommendedSlots.push(item);
      });

    const slotNames = [
      "Best Match",
      "Second Best Match",
      "Third Best Match",
      "Fourth Best Match",
      "Fifth Best Match",
      "Sixth Best Match",
      "Seventh Best Match",
      "Eighth Best Match",
      "Ninth Best Match",
      "Tenth Best Match"
    ];

    recommendedSlots.forEach(
      function (item, index) {
        item.slotName =
          slotNames[index] ||
          "Recommended Match";
      }
    );

    const selectedSymbols =
      Object.keys(stepSelectionsMeta)
        .sort(function (a, b) {
          return Number(a) - Number(b);
        })
        .map(function (key) {
          return stepSelectionsMeta[key].symbol;
        })
        .filter(Boolean);

    resultsProfileLine.textContent =
      selectedSymbols.join("  |  ");

    resultsCardsContainer.innerHTML = "";

    const recommendedHandles =
      recommendedSlots.map(function (item) {
        return item.shopifyProduct.handle;
      });

    trackEvent("quiz_completed", {
      profile: selectedSymbols.join(" "),
      current_perfumes: perfumeEntries,
      recommended_handles: recommendedHandles
    });

    const activeMaximumScore =
      getActiveMaximumScore();

    recommendedSlots.forEach(
      function (item, index) {
        const p = item.shopifyProduct;
        const pTags = normalizeArray(p.tags);

        const calculatedPercentage =
          Math.round(
            (
              item.coreScore /
              activeMaximumScore
            ) * 100
          );

        // Named exact/flanker matches are prioritised directly.
        const matchPercentage =
          item.isNamedMatch
            ? 99
            : Math.min(
                Math.max(
                  calculatedPercentage,
                  0
                ),
                100
              );

        let fitReasonItems = "";

        if (item.isNamedMatch) {
          fitReasonItems += `
            <li class="bps-result-reason-item">
              Matches the perfume line you entered:
              ${escapeHtml(item.namedMatchInput)}
            </li>
          `;
        }

        if (!isAnyAnswer(answers.direction)) {
          fitReasonItems += `
            <li class="bps-result-reason-item">
              Matches your selected
              ${String(answers.direction).toUpperCase()}
              scent category
            </li>
          `;
        }

        if (item.referenceScore > 0) {
          const noteCountText =
            item.referenceScore === 100
              ? "three or more"
              : item.referenceScore === 67
                ? "two"
                : "one";

          fitReasonItems += `
            <li class="bps-result-reason-item">
              Matches ${noteCountText}
              of your preferred scent-note families
            </li>
          `;
        }

        if (item.occasionScore === 100) {
          fitReasonItems += `
            <li class="bps-result-reason-item">
              Matches your selected time or occasion
            </li>
          `;
        }

        if (item.strengthScore === 100) {
          fitReasonItems += `
            <li class="bps-result-reason-item">
              Matches your preferred
              ${String(answers.strength).toUpperCase()}
              strength
            </li>
          `;
        }

        if (pTags.includes("bestseller")) {
          fitReasonItems += `
            <li class="bps-result-reason-item">
              Prioritised as a store Bestseller
              after preference matching
            </li>
          `;
        }

        const familiesList =
          pTags.filter(function (tag) {
            return [
              "floral",
              "fruity",
              "sweet",
              "woody",
              "citrus",
              "spicy",
              "amber",
              "aromatic",
              "sea",
              "green",
              "powdery",
              "vanilla",
              "tobacco",
              "oud",
              "leather",
              "musk",
              "musky",
              "fresh",
              "clean"
            ].includes(tag);
          });

        if (familiesList.length > 0) {
          const uppercaseFamilies =
            familiesList
              .map(function (family) {
                return (
                  family.charAt(0).toUpperCase() +
                  family.slice(1)
                );
              })
              .join(", ");

          fitReasonItems += `
            <li class="bps-result-reason-item">
              Features premium notes:
              ${uppercaseFamilies}
            </li>
          `;
        }

        if (!fitReasonItems) {
          fitReasonItems = `
            <li class="bps-result-reason-item">
              Highest available match
              from the current catalogue
            </li>
          `;
        }

        let diffNoteText = "";

        if (pTags.includes("sweet")) {
          diffNoteText =
            "Dials up the rich, warm sweetness for an extremely sensual dry down that commands high attention.";
        } else if (
          pTags.includes("fresh") ||
          pTags.includes("citrus")
        ) {
          diffNoteText =
            "Accents vibrant fresh citrus and aquatic accords, keeping the opening clean and highly refreshing.";
        } else if (
          pTags.includes("woody") ||
          pTags.includes("niche")
        ) {
          diffNoteText =
            "Blends deeper, refined rare precious wood accords for an expensive-feeling signature depth.";
        } else if (
          pTags.includes("floral")
        ) {
          diffNoteText =
            "Features airier, highly romance-friendly fresh floral petals for a soft close-to-skin experience.";
        } else {
          diffNoteText =
            "Formulated with elevated perfume concentrations, ensuring a cleaner opening and longer-lasting wear.";
        }

        const visibleBadges =
          pTags.filter(function (tag) {
            return (
              !/^\d+$/.test(tag) &&
              tag !== "numbers" &&
              [
                "strong",
                "bestseller",
                "everyday",
                "niche",
                "clean",
                "moderate",
                "light",
                "sweet",
                "floral",
                "fresh",
                "citrus",
                "woody"
              ].includes(tag)
            );
          });

        const productPrice =
          (p.price_min / 100).toFixed(2);

        const card =
          document.createElement("div");

        card.className =
          "bps-result-card";

        card.innerHTML = `
          <span class="bps-result-badge-top">
            ${item.slotName}
          </span>

          <div class="bps-result-card-image-wrap">
            <img
              class="bps-result-card-image"
              src="${p.image}"
              alt="${p.title}"
            >
          </div>

          <div class="bps-result-card-content">
            <div class="bps-result-card-header">
              <span class="bps-result-match-percentage">
                ${matchPercentage}% Match
              </span>

              <div class="bps-result-title-row">
                <h2 class="bps-result-name">
                  ${p.title}
                </h2>
              </div>

              <div class="bps-result-inspired-html">
                ${p.richText || ""}
              </div>

              <div class="bps-result-badges-list">
                <span class="bps-result-badge-pill">
                  Match score: ${item.score}
                </span>

                ${visibleBadges
                  .map(function (badge) {
                    return `
                      <span class="bps-result-badge-pill">
                        ${badge.toUpperCase()}
                      </span>
                    `;
                  })
                  .join("")}
              </div>
            </div>

            <div class="bps-result-card-body">
              <h4 class="bps-result-reason-title">
                Why this fits you:
              </h4>

              <ul class="bps-result-reason-list">
                ${fitReasonItems}
              </ul>

              <div class="bps-result-difference">
                <strong>How it differs:</strong>
                ${diffNoteText}
              </div>
            </div>

            <div class="bps-result-card-actions">
              ${
                p.available === false
                  ? `
                    <button
                      class="bps-btn bps-btn-secondary bps-add-to-cart-btn"
                      disabled
                      style="opacity: 0.5; cursor: not-allowed; border-color: #222;"
                    >
                      Sold Out
                    </button>
                  `
                  : `
                    <button
                      class="bps-btn bps-btn-primary bps-add-to-cart-btn"
                      data-variant-id="${p.variantId}"
                      data-handle="${p.handle}"
                    >
                      Add to Cart — $${productPrice}
                    </button>
                  `
              }

              <a
                href="${p.url}#block_disction"
                class="bps-btn bps-btn-secondary bps-view-product-btn"
                data-handle="${p.handle}"
              >
                View Product
              </a>
            </div>
          </div>
        `;

        resultsCardsContainer.appendChild(card);

        trackEvent("recommendation_viewed", {
          product_handle: p.handle,
          rank: index + 1,
          score: item.score,
          core_score: item.coreScore,
          bestseller_bonus: item.bestsellerBonus,
          named_match: item.isNamedMatch === true,
          result_slot: item.slotName
        });
      }
    );

    bindResultActions();
  }

  // ==========================================================================
  // 8. Cart Additions & Interactions Handler
  // ==========================================================================

  function bindResultActions() {
    document
      .querySelectorAll(".bps-add-to-cart-btn")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          const variantId =
            btn.getAttribute("data-variant-id");

          const handle =
            btn.getAttribute("data-handle");

          if (!variantId) {
            console.error(
              "[Quiz] Missing variant ID"
            );

            return;
          }

          const originalText =
            btn.textContent;

          btn.disabled = true;
          btn.textContent = "Adding...";

          fetch("/cart/add.js", {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json"
            },

            body: JSON.stringify({
              items: [
                {
                  id: parseInt(
                    variantId,
                    10
                  ),

                  quantity: 1
                }
              ]
            })
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              btn.textContent =
                "Added to Cart!";

              btn.style.background =
                "#2e7d32";

              btn.style.color =
                "#ffffff";

              btn.style.borderColor =
                "#2e7d32";

              trackEvent(
                "add_to_cart_from_quiz",
                {
                  product_handle: handle,
                  variant_id: variantId
                }
              );

              if (
                window.theme &&
                typeof window.theme.CartDrawer ===
                  "function"
              ) {
                // Standard theme updater callbacks can go here.
              }

              document.dispatchEvent(
                new CustomEvent(
                  "ajaxProduct:added",
                  {
                    detail: {
                      product: data
                    }
                  }
                )
              );
            })
            .catch(function (err) {
              console.error(
                "[Quiz] Cart add failed:",
                err
              );

              btn.textContent =
                "Error Adding!";

              btn.style.background =
                "#c62828";

              setTimeout(function () {
                btn.disabled = false;

                btn.textContent =
                  originalText;

                btn.style.background =
                  "#ffffff";

                btn.style.color =
                  "#000000";

                btn.style.borderColor =
                  "#ffffff";
              }, 2000);
            });
        });
      });

    document
      .querySelectorAll(".bps-view-product-btn")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          const handle =
            btn.getAttribute("data-handle");

          trackEvent(
            "recommendation_clicked",
            {
              product_handle: handle
            }
          );
        });
      });
  }

  // ==========================================================================
  // 9. Analytics & Pixel Tracking Integrator
  // ==========================================================================

  function trackStepAnswer(
    stepName,
    answerValue,
    symbol,
    label
  ) {
    const profileSoFar = [];

    for (const key in stepSelectionsMeta) {
      profileSoFar.push(
        `${stepSelectionsMeta[key].symbol} ${stepSelectionsMeta[key].label}`
      );
    }

    trackEvent("quiz_step_answered", {
      step: stepName,
      answer: answerValue,
      symbol: symbol,
      label: label,
      profile_so_far: profileSoFar
    });
  }

  function trackEvent(eventName, payload) {
    console.log(
      `[Quiz Tracking] Event: ${eventName}`,
      payload
    );

    if (
      window.dataLayer &&
      typeof window.dataLayer.push ===
        "function"
    ) {
      window.dataLayer.push({
        event: eventName,
        quiz_data: payload
      });
    }

    const customEv =
      new CustomEvent(eventName, {
        detail: payload,
        bubbles: true,
        cancelable: true
      });

    document.dispatchEvent(customEv);
  }
});